import {
  CARD_CONTENT_ALLOWED_ATTR,
  CARD_CONTENT_ALLOWED_TAGS,
} from 'klue-html';
import sanitize from 'klue-html/sanitizer';

function sanitizeText(text: string) {
  return sanitize(text, {
    ALLOWED_TAGS: CARD_CONTENT_ALLOWED_TAGS,
    ADD_ATTR: CARD_CONTENT_ALLOWED_ATTR,
  });
}

export default sanitizeText;
